import { GlobalConfig } from 'ngx-toastr';

export const DEFAULT_TOAST_CONFIG: Partial<GlobalConfig> = {
	preventDuplicates: true,
	closeButton: true,
	timeOut: 800,
};
